<!-- /**
 * @author Ketan Shetye
 * @created 2025-10-25
 */ -->
@if (data.variant === 'basic') {
<button mat-button class="common-button basic-button" [type]="data.type" [disabled]="data.disabled" [disableRipple]="data.disableRipple" (click)="handleClick($event)">
    @if (isTemplate(data.text)) {
      <ng-container *ngTemplateOutlet="data.text"></ng-container>
    } @else {
      {{ data.text }}
    }
</button>
} @else if (data.variant === 'raised') {
<button mat-raised-button [class]="data.className" [type]="data.type" [disabled]="data.disabled" [disableRipple]="data.disableRipple" (click)="handleClick($event)">
    @if (isTemplate(data.text)) {
      <ng-container *ngTemplateOutlet="data.text"></ng-container>
    } @else {
      {{ data.text }}
    }
</button>
} @else if (data.variant === 'stroked') {
<button mat-stroked-button [class]="data.className" [type]="data.type" [disabled]="data.disabled" [disableRipple]="data.disableRipple" (click)="handleClick($event)">
    @if (isTemplate(data.text)) {
      <ng-container *ngTemplateOutlet="data.text"></ng-container>
    } @else {
      {{ data.text }}
    }
</button>
} @else if (data.variant === 'flat') {
<button mat-flat-button [class]="data.className" [type]="data.type" [disabled]="data.disabled" [disableRipple]="data.disableRipple" (click)="handleClick($event)">
    @if (isTemplate(data.text)) {
      <ng-container *ngTemplateOutlet="data.text"></ng-container>
    } @else {
      {{ data.text }}
    }
</button>
} @else if (data.variant === 'icon') {
<button mat-icon-button [class]="data.className" [type]="data.type" [disabled]="data.disabled" [disableRipple]="data.disableRipple" (click)="handleClick($event)">
    @if (isTemplate(data.text)) {
      <ng-container *ngTemplateOutlet="data.text"></ng-container>
    } @else {
        @if(data.iconName){
          <wm-common-icon
            [data]="{ iconName: data.iconName }">
          </wm-common-icon>
        } @else {
          <mat-icon>{{ data.text }}</mat-icon>
        }
      }    
</button>
} @else if (data.variant === 'fab') {
<button mat-fab [class]="data.className" [type]="data.type" [disabled]="data.disabled" [disableRipple]="data.disableRipple" (click)="handleClick($event)">
    @if (isTemplate(data.text)) {
      <ng-container *ngTemplateOutlet="data.text"></ng-container>
    }
</button>
} @else if (data.variant === 'mini-fab') {
<button mat-mini-fab [class]="data.className" [type]="data.type" [disabled]="data.disabled" [disableRipple]="data.disableRipple" (click)="handleClick($event)">
    @if (isTemplate(data.text)) {
      <ng-container *ngTemplateOutlet="data.text"></ng-container>
    }
</button>
}